import { render, staticRenderFns } from "./imports_bulk_select_rubric.vue?vue&type=template&id=41659a83&"
import script from "./imports_bulk_select_rubric.vue?vue&type=script&lang=js&"
export * from "./imports_bulk_select_rubric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports